export default __webpack_public_path__ + "static/media/twenty-three.cfce6a1e.png";